__turbopack_context__.v({
  "button": "Lightbox-module-scss-module__yFWQBG__button",
  "buttonWrapper": "Lightbox-module-scss-module__yFWQBG__buttonWrapper",
  "lightbox": "Lightbox-module-scss-module__yFWQBG__lightbox",
  "lightboxCloseButton": "Lightbox-module-scss-module__yFWQBG__lightboxCloseButton",
  "lightboxWrapper": "Lightbox-module-scss-module__yFWQBG__lightboxWrapper",
  "textWrapper": "Lightbox-module-scss-module__yFWQBG__textWrapper",
});
